import { type BaseComponentProps, type ContentfulLinkType } from '@bedrock/core/contentful';
import { Button, type ButtonProps } from '@bedrock/ui/button';
import { cn } from '@bedrock/ui/utils';
import { ContentfulLink } from 'ui/ui-patterns/components/contentful-link';
import { ctaBlockVariants, ctaItemVariants } from './variants';

export type CtaContainerProps = Readonly<{
  className?: string;
  cta: ContentfulLinkType[];
  locale: BaseComponentProps['locale'];
  horizontalPosition?: 'left' | 'center' | 'right';
  size?: ButtonProps['size'];
}>;

export function CtaContainer({
  className,
  cta,
  locale,
  horizontalPosition = 'left',
  size = 'unset',
}: Readonly<CtaContainerProps>) {
  return (
    <div className={cn(ctaBlockVariants({ horizontalPosition }), className)}>
      {cta.map((link, index) => (
        <Button
          // eslint-disable-next-line react/no-array-index-key -- Contentful may return duplicate items, so a stable unique key isn't available
          key={`${link.sysId}-${index}`}
          asChild
          className={ctaItemVariants({ horizontalPosition })}
          size={size}
          // @ts-expect-error All unmatched variants are filtered out earlier
          variant={link.type || 'primary'}
        >
          <ContentfulLink link={link} locale={locale}>
            {link.label}
          </ContentfulLink>
        </Button>
      ))}
    </div>
  );
}
